import type React from 'react';

function SvanenIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 371 371"
      fill="#079b49"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Svanen Icon</title>
      <path d="M135.07,6.58L0,192.96v-7.02C0,100.86,57.01,28.94,135.07,6.58m156.12,25.43c-10.52-7.02-21.49-13.16-33.33-17.98L91.22,243.83c7.46,3.95,11.84,10.96,25,10.96,7.46,0,17.1-4.82,26.31-17.54L291.19,32.45v-.44ZM17.54,264.87c12.72,0,29.38-4.82,38.59-11.84,8.33-7.02,13.16-12.72,21.93-12.72h3.95L249.09,10.09c-12.72-4.39-25.87-7.89-39.91-9.65L17.54,264.44h0m3.95,8.33c4.82,9.21,10.52,17.98,17.1,26.31l19.3-26.31H21.49Zm222.78,0l-71.48,98.23h13.16c12.28,0,24.12-1.32,35.52-3.51l69.29-95.16h-46.48v.44ZM198.22,0h-12.28c-12.72,0-25,1.32-36.84,3.51L.88,207.43c1.75,16.66,6.14,32.45,11.84,47.8L198.22,0Zm104.37,273.21l-66.66,92.09c49.55-13.59,90.78-47.36,114.9-92.09h-48.24Zm-116.65,0l-63.59,87.71c12.72,4.82,25.87,7.89,39.47,9.65l70.6-97.35h-46.48Zm-58.33,0l-47.8,65.78c10.52,7.02,21.49,13.59,33.33,18.42l60.96-84.2h-46.48Zm-58.33,0l-24.56,34.21c8.33,9.65,17.54,18.42,27.63,26.31l43.85-60.08h-46.48l-.44-.44Zm8.33-27.19c-3.95,0-6.58,3.07-6.58,6.58s3.07,6.58,6.58,6.58,6.58-3.07,6.58-6.58-3.07-6.58-6.58-6.58m294.26-68.85c0-4.82-.44-9.65-1.32-14.47l-65.34,89.9h11.84l54.82-75.43Zm-17.98-71.48l-107,147.35h11.4l99.55-137.26c-1.32-3.51-2.63-6.58-4.39-10.09m-27.63-42.1L188.13,253.03h11.84L331.97,71.04c-2.19-2.63-3.95-5.26-6.14-7.46" />
    </svg>
  );
}

export default SvanenIcon;
